import { Button } from "../../../ui-components";
import { useNavigate } from "react-router-dom";
import { route } from "../../../routes";
import { BondDetailLogo } from "./BondDetailLogo";
import { FavorBond } from "./FavorBond";
import { PricedBond } from "../PricedBond";
import "./BondDetail.scss";
import "./FavorBond.scss";

export const BondDetailHeader = ({ pricedBond }: { pricedBond: PricedBond }) => {
  const navigate = useNavigate();

  const bondId = pricedBond.bondIdCusip;
  const issuerTicker = pricedBond.issuerTicker;
  const issuerName = pricedBond.issuerName;

  const navigateToInvest = () => {
    navigate(route.orderBuy(bondId));
  };

  return (
    <div className="grid sm:grid-cols-3 bg-neutral-103 text-primary-500 dark:bg-primary-400 rounded-t-2xl sm:h-44 h-32 lg:px-20 px-10 relative border-b border-solid border-b-[#D0D0D0]">
      <div className="flex gap-1 items-center justify-center">
        <BondDetailLogo issuerTicker={issuerTicker} className="w-[54px] h-[54px]" />
        <div className="font-bold lg:text-[24px] text-lg flex flex-col justify-end leading-[23px] ">{issuerName}</div>
      </div>
      <div className="flex items-center justify-center">
        <Button
          fill
          size={"medium"}
          primary
          uppercase={false}
          font={"medium"}
          onClick={navigateToInvest}
          className="opacity-90 w-32"
        >
          Invest
        </Button>
      </div>
      <div className="flex items-center sm:justify-end justify-center favorBond_starResponsive">
        <FavorBond pricedBond={pricedBond} size={30} />
      </div>
    </div>
  );
};
